import type { DocumentRegistryEntry } from '@kennisbank/shared';
import { versionBadge } from '../lib/document-versions.js';

/**
 * "Superseded" / "Current version" chip for a /documents row. Superseded
 * copies stay listed and searchable — the assistant just prefers the newer
 * one — so the chip is informational, in the neutral grey tone; the
 * current-version hint uses the Ring 1 tint.
 */
export function VersionBadge({
  doc,
}: {
  doc: Pick<DocumentRegistryEntry, 'versionStatus' | 'supersededBy'>;
}): JSX.Element | null {
  const badge = versionBadge(doc);
  if (!badge) return null;
  const tone =
    badge.kind === 'superseded'
      ? 'bg-nebula-gray-5 text-nebula-fg-3'
      : 'bg-nebula-tint text-nebula-secondary';
  return (
    <span
      title={badge.tooltip}
      className={`mt-0.5 inline-flex flex-shrink-0 items-center rounded-md px-1.5 py-0.5 text-[10px] font-medium ${tone}`}
    >
      {badge.label}
    </span>
  );
}
